import { isStrictPasswordPolicyEnabled } from '@/service/administratorPassword/isStrictPasswordPolicyEnabled';

// 旧世代側（manage/js/profile.js）のコントローラから新パスワードポリシーのフラグ判定を使うためのブリッジ。
// 下位の isExistFeatureFlag / isBetaFacility が内部で例外を吸収して false を返すため、ここでの try/catch は不要。
angular.module('inspinia').factory('administratorPasswordService', function () {
  return {
    isStrictPasswordPolicyEnabled,
  };
});
